__turbopack_context__.v({
  "ant-dropdown-button": "Header-module-scss-module__2HQFkq__ant-dropdown-button",
  "ant-dropdown-link": "Header-module-scss-module__2HQFkq__ant-dropdown-link",
  "ant-dropdown-trigger": "Header-module-scss-module__2HQFkq__ant-dropdown-trigger",
  "ant-menu-item": "Header-module-scss-module__2HQFkq__ant-menu-item",
  "ant-menu-title-content": "Header-module-scss-module__2HQFkq__ant-menu-title-content",
  "ant-modal-close": "Header-module-scss-module__2HQFkq__ant-modal-close",
  "ant-modal-close-icon": "Header-module-scss-module__2HQFkq__ant-modal-close-icon",
  "ant-modal-content": "Header-module-scss-module__2HQFkq__ant-modal-content",
  "anticon": "Header-module-scss-module__2HQFkq__anticon",
  "anticon-down": "Header-module-scss-module__2HQFkq__anticon-down",
  "dashboardButton": "Header-module-scss-module__2HQFkq__dashboardButton",
  "dashboardButtonText": "Header-module-scss-module__2HQFkq__dashboardButtonText",
  "headerMenu": "Header-module-scss-module__2HQFkq__headerMenu",
  "headerMenuItemBadge": "Header-module-scss-module__2HQFkq__headerMenuItemBadge",
  "headerMenuLink": "Header-module-scss-module__2HQFkq__headerMenuLink",
  "headerMenuMobile": "Header-module-scss-module__2HQFkq__headerMenuMobile",
  "headerTransparent": "Header-module-scss-module__2HQFkq__headerTransparent",
  "headerWrapper": "Header-module-scss-module__2HQFkq__headerWrapper",
  "leftMenuDesktop": "Header-module-scss-module__2HQFkq__leftMenuDesktop",
  "loginButtonDesktop": "Header-module-scss-module__2HQFkq__loginButtonDesktop",
  "loginButtonDrawer": "Header-module-scss-module__2HQFkq__loginButtonDrawer",
  "moreMenu": "Header-module-scss-module__2HQFkq__moreMenu",
  "navWrapper": "Header-module-scss-module__2HQFkq__navWrapper",
  "normalDrawer": "Header-module-scss-module__2HQFkq__normalDrawer",
  "normalDropdownOverlay": "Header-module-scss-module__2HQFkq__normalDropdownOverlay",
  "rightMenuDesktop": "Header-module-scss-module__2HQFkq__rightMenuDesktop",
  "rightMenuMobile": "Header-module-scss-module__2HQFkq__rightMenuMobile",
  "searchButton": "Header-module-scss-module__2HQFkq__searchButton",
  "searchModal": "Header-module-scss-module__2HQFkq__searchModal",
  "subMenuDropdown": "Header-module-scss-module__2HQFkq__subMenuDropdown",
  "upgradeBtn": "Header-module-scss-module__2HQFkq__upgradeBtn",
});
